<template>
    <div class="cloneable-tools">
        <draggable :group="{name: group, pull: 'clone', put: false}"
                   :sort="false"
                   item-key="id"
                   :clone="cloneTool"
                   class="tools"
                   v-model="tools">
            <template #item="{element}">
                <div class="tool">
                    <button class="btn btn-block btn-icon" :class="exists( element ) ? 'btn-warning' : 'btn-light'" @click="preview(element)">
                        <img :src="iconPreview(element)" alt="">
                        <span class="label">{{ element.name }}</span>
                    </button>
                    <div class="tool-actions" v-if="$slots['tool-actions']">
                        <slot name="tool-actions" :element="element"></slot>
                    </div>
                </div>
            </template>
        </draggable>


        <modal :id="utils.randomId({prefix: 'modal'})"
               :show="true"
               size="xl"
               v-if="modal.item"
               @click.prevent.stop=""
               @close="close()">

            <template #title>
                {{ modal.item.name }}
            </template>


            <markdown-text v-if="modal.item?.data?.description"
                           :content="modal.item?.data?.description" />

            <div v-if="modal.item?.data?.type === 'link' && modal.item?.data?.url"
                 class="mb-3">
                <strong>External Link: </strong>
                <a target="_blank" :href="modal.item?.data?.url">
                    {{ utils.ellipsis(modal.item?.data?.url) }}
                </a>
            </div>

            <div class="frame-wrapper">
                <template v-if="modal.item?.data?.type === 'embed'">
                    <div v-html="modal.item?.data?.url"></div>
                </template>

                <iframe v-else class="w-100 border-0"
                        :src="`${preview_url ? uploads.url( preview_url ) : 'https://via.placeholder.com/240x240?text=PREVIEW'}`" alt=""></iframe>
            </div>


            <template v-if="modal.item?.data?.teacher_instructions">
                <h5>Instructions</h5>
                <markdown-text :content="modal.item.data.teacher_instructions" />
            </template>

            <template #footer>
                <slot name="preview-actions" :item="modal"></slot>
                <a v-if="modal.item?.data?.type !== 'embed' && modal.item?.data?.file"
                   :href="uploads.url( modal.item.data.file?.url )"
                   target="_blank"
                   type="button"
                   class="btn btn-success ml-auto">Download</a>
            </template>
        </modal>

    </div>
</template>

<script>
import draggable from 'vuedraggable';
import Modal from "@/Components/Common/Modal";
import MarkdownText from "@/Components/Common/MarkdownText";
import utils from "@/mixins/utils";
import uploads from "@/mixins/uploads";

export default {
    name: "CloneableTools",
    components: {draggable, Modal, MarkdownText},
    props: ['tools', 'group', 'activities', 'resources', 'busyActivities', 'busyResources'],
    mixins: [utils, uploads],

    data(){
        return {
            modal: {
                item: null,
            },
            is_dragging: false,
            mouse: {
                x: 0,
                y: 0,
            }
        }
    },


    computed: {
        preview_url(){
            if( this.modal.item?.data?.preview_url ) return this.modal.item?.data?.preview_url;
            if( this.modal.item?.data?.preview_file?.preview_url ) return this.modal.item?.data?.preview_file?.preview_url;
            if( this.modal.item?.data?.file?.preview_url ) return this.modal.item?.data?.file?.preview_url;
            return null;
        },
    },

    methods: {

        iconPreview(element){
            return this.uploads.image(this.icon(element), {w: 120, h:80, c:true});
        },

        icon(element){
            if( element.data.preview_file ){
                if( element.data.preview_file?.preview_url ){
                    return element.data.preview_file.preview_url;
                }else if( element.data.preview_file?.url ){
                    return element.data.preview_file.url;
                }
            }

            if( element.data.preview_url && element.data.preview_url !== '' ) return element.data.preview_url;
            if( element.data.file?.preview_url && element.data.file?.preview_url !== '' ) return element.data.file?.preview_url;

            switch ( element.data.file?.mime ){
                case 'image/jpg':
                case 'image/jpeg':
                case 'image/png':
                case 'image/gif':
                case 'application/pdf':
                    return element.data.file.url
            }
        },

        exists(item){
            return false;
        },

        cloneTool(tool){
            // TODO: Create a concrete object of the tool type and return

            // switch (this.group){
            //     case 'resource':
            //         return {
            //             id: this.random(10000, 9999999999),
            //             type: 'link',
            //             owner: 'dfc',
            //             title: 'How to get started in analyzing a problem in a community.',
            //             color: this.hslToHex( this.random(0, 360), this.random( 0, 100 ), this.random(10, 50) ),
            //             data: 'https://google.com',
            //         };
            //
            //     case 'activity':
            //         return {
            //             id: this.random(10000, 9999999999),
            //             type: tool.type,
            //             icon: tool.icon,
            //             name: tool.name,
            //             description: tool.description,
            //             file: {
            //                 url: 'http://www.africau.edu/images/default/sample.pdf'
            //             },
            //             options: {
            //                 width: 3
            //             }
            //         }
            // }

            // TODO: Control each tool and data through it's initialization method of the tool class.

            const element = _.clone( tool );

            switch (element.type){
                case 'resource':
                    element.color = this.utils.hslToHex( this.utils.random(0, 360), this.utils.random( 0, 80 ), this.utils.random(40, 75) );
            }

            return {
                id: this.utils.randomId({prefix: 'el'}),
                element,
            };

        },

        preview(element){
            this.modal.item = element;
        },

        close(){
            this.modal.item = null;
        },

    },


}
</script>

<style lang="scss" scoped>
.btn{
    display: flex;
    align-items: center;
    text-align: left;
    margin-bottom: 0.4rem;

    //img{
    //    display: block;
    //    width: 24px;
    //    height: 24px;
    //    flex: 0 0 24px;
    //    object-fit: contain;
    //    margin-right: 0.5rem;
    //}
}

.app-content-pane{
    .btn.sortable-chosen{
        width: auto;
        height: auto;
        overflow: hidden;
        text-overflow: ellipsis;
        min-width: 20%;
        text-align: center;
    }
}


.tools{
    display: flex;
    flex-wrap: wrap;
    margin-left: -0.3rem;
    margin-right: -0.3rem;
    align-items: stretch;
    position: relative;
}

.tool{
    flex: 0 0 33.33333333%;
    width: 33.333333333%;
    padding-left: 0.3rem;
    padding-right: 0.3rem;
    display: flex;
    align-items: stretch;
    position: relative;
}



.btn-icon{
    display: flex;
    flex-direction: column;
    line-height: 1.15;
    font-size: 0.85rem;
    text-align: center;
    padding: 0;

    img{
        width: 100%;
        height: auto;
    }

    .label{
        padding: 0.3rem;
        flex-grow: 1;
        display: flex;
        align-items: center;
        justify-content: center;
    }
}

@media (min-width: 650px) and (max-width: 1199px){
    .tool{
        flex: 0 0 100%;
        width: 100%;
        padding-left: 0.3rem;
        padding-right: 0.3rem;
    }

    .btn-icon{
        display: flex;
        flex-direction: row;
        line-height: 1.15;
        font-size: 0.85rem;
        text-align: center;
        padding: 0;

        img{
            width: 50%;
            height: auto;
        }

        .label{
            padding: 0.3rem;
            flex-grow: 1;
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }
}

.tool-actions{
    position: absolute;
    left: .3rem;
    right: .3rem;
}

</style>
